import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { getUser, getIdToken, getClient } from "../../utils/storage";
import Demographics from "../Shared/createCampaign/Demographics";
import SampleSize from "../Shared/createCampaign/SampleSize";
import CampaignTask from "../Shared/createCampaign/CampaignTask";
import DummyButton from "../DummyButton";
import {
  createMultiMediaCampaign,
  interactTypes,
  mediaTypes,
} from "../../services/dashboard-api";

const NewRequestModal = (props) => {
  const {
    isNewRequestModalOpen,
    toggleNewRequestModalOpen,
    setToast,
    tooltip,
    setTooltip,
  } = props;

  const history = useHistory();

  // const [newRequestStep, setNewRequestStep] = useState("one"); // "one", "two", "three"
  // const [requestType, setRequestType] = useState(null); // "campaign", "request"
  const [newRequestStep, setNewRequestStep] = useState("one");
  const [requestType, setRequestType] = useState("request");
  const [interactTypesOptions, setInteractTypesOptions] = useState([]); // State to store fetched interact types
  const [mediaTypesOptions, setMediaTypesOptions] = useState([]); // State to store fetched media types
  const [showDummyButton, setShowDummyButton] = useState(false);
  const [insuffientFunds, setInsuffientFunds] = useState(false);
  const [creditsPerRespondent_interact, setCreditsPerRespondent_interact] =
    useState(0);
  const [usdPerRespondent_interact, setUsdPerRespondent_interact] = useState(0);

  const country = "Nigeria";

  const defaultRequestData = {
    requestName: "",
    description: "",
    gender: [],
    startAge: "26",
    endAge: "45",
    country: process.env.REACT_APP_VERSUS_ENV === "dev" ? 160 : 38,
    stateOrRegion: [],
    numberOfRespondents: "500",
    mediaTypeId: null, // MODIFIED: Changed to mediaTypeId and default to null
    interactTypeId: null,
    interest_ids: [],
    lga_ids: [],
    sports_fan: false,
    soccer_fan: "",
    favorite_team_id: "",
    category: "",
    link: "",
    instructions: "",
  };

  const user = getUser(),
    idToken = getIdToken(),
    client = getClient();

  const gotoSurveyStep = (step) => setNewRequestStep(step);

  const closeNewRequestModal = () => {
    setNewRequestStep("one");
    toggleNewRequestModalOpen();
  };

  const [newRequestData, setNewRequestData] = useState(defaultRequestData);

  // MODIFIED: This function will now update mediaTypeId with the actual ID
  const setMediaType = (conceptualName) => {
    // Takes the conceptual name like "Photo", "Video", "Audio"
    setNewRequestData({
      ...newRequestData,
      mediaTypeId: getMediaTypeId(conceptualName), // Get the ID from options
    });
  };

  const setSportsFan = (e) => {
    setNewRequestData({
      ...newRequestData,
      sports_fan: e.currentTarget.value === "true",
    });
  };

  const openModal = (value) => {
    if (value === "Two") {
      gotoSurveyStep("two");
      setTooltip({
        show: true,
        type: "",
        title: "",
        message: "",
        step: 5.3,
        max_step: 5,
      });
    }
    if (value === "Three") {
      gotoSurveyStep("three");
      setTooltip({
        show: true,
        type: "",
        title: "",
        message: "",
        step: 5.6,
        max_step: 5,
      });
    }
  };

  const handleNewRequestData = (e) => {
    if (e.target.name === "numberOfRespondents") {
      if (
        e.target.value * creditsPerRespondent_interact >
        client.versusCredits
      ) {
        setToast({
          show: true,
          type: "warning",
          message: `You should buy more versus credits to target more than ${client.versusCredits} respondents`,
        });
        setInsuffientFunds(true);
      } else {
        setToast({ show: false, type: "", message: "" });
        e.target.value = Math.ceil(e.target.value);
        setInsuffientFunds(false);
      }
      setNewRequestData({
        ...newRequestData,
        numberOfRespondents: e.target.value,
      });
    } else if (e.target.name === "gender") {
      const { checked, value } = e.target;
      let genders = newRequestData.gender.slice();
      if (checked) {
        if (!genders.includes(value)) {
          genders.push(value);
        }
      } else {
        if (genders.includes(value)) {
          genders = genders.filter((g) => g !== value);
        }
      }
      setNewRequestData({ ...newRequestData, gender: genders });
    } else if (e.target.name === "soccer_fan") {
      let { checked } = e.target;
      setNewRequestData({ ...newRequestData, [e.target.name]: checked });
    } else {
      setNewRequestData({ ...newRequestData, [e.target.name]: e.target.value });
    }
  };

  const handleSliderChange = (values) =>
    setNewRequestData({
      ...newRequestData,
      startAge: values[0],
      endAge: values[1],
    });

  const handleCreateNewRequest = () => {
    const {
      requestName,
      description,
      gender,
      startAge,
      endAge,
      country,
      stateOrRegion,
      numberOfRespondents,
      mediaTypeId, // MODIFIED: Get mediaTypeId from state
      interactTypeId,
      soccer_fan,
      sports_fan,
      interest_ids,
      lga_ids,
      favorite_team_id,
      category,
      link,
      instructions,
    } = newRequestData;

    const payload = {
      clientRef: client.client.clientRef,
      requestName,
      description,
      gender: gender.filter(Boolean).map(Number),
      ...(category && { category }),
      ...(link && { link }),
      ...(instructions && { instructions }),
      startAge: Number(startAge),
      endAge: Number(endAge),
      interestIds: [String(interest_ids)],
      country: Number(country),
      lga_ids: lga_ids,
      stateOrRegion: Array.isArray(Number(stateOrRegion))
        ? Number(stateOrRegion)
        : [],
      numberOfRespondents: Number(numberOfRespondents),
      interactTypeId: interactTypeId,
      mediaType: mediaTypeId,
      statusId: 1,
    };

    console.log("payload", gender.filter(Boolean).map(Number));

    createMultiMediaCampaign(payload)
      .then((result) => {
        if (result.status === 200) {
          setToast({
            show: true,
            type: "success",
            message: "Your request has been created",
          });
          setShowDummyButton(false);
          setNewRequestStep("one");
          setNewRequestData(defaultRequestData);
          toggleNewRequestModalOpen();
          const requestRef = result.data.mmCampaign.mmCampaignRef;
          history.push(`/dashboard/interact/request/${requestRef}`);
        }
        console.log(result);
      })
      .catch((error) => {
        setShowDummyButton(false);
        setToast({
          show: true,
          type: "danger",
          message:
            error?.response?.data?.message ||
            "Fail. Something must have gone wrong",
        });
      });
  };

  useEffect(() => {
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/versus_v2_get_client_settings`,
        {
          uid: getUser().uid,
          idToken: getIdToken(),
        },
        { headers: { "content-type": "application/json" } }
      )
      .then(({ data }) => {
        setCreditsPerRespondent_interact(
          data?.clientSettings?.creditsPerRespondent_interact
        );
        setUsdPerRespondent_interact(
          data?.clientSettings?.usdPerRespondent_interact
        );
      })
      .catch((error) => {
        console.log("Error getting client settings:", error);
      });

    // Fetch Interact Types
    const getInteractTypes = async () => {
      try {
        const { data } = await interactTypes();
        const interactTypeResponse = data?.data;
        setInteractTypesOptions(interactTypeResponse);
      } catch (error) {
        console.log("Error obtaining interact types", error.message);
      } finally {
        console.log("Done fetching interact types");
      }
    };
    getInteractTypes();

    // Fetch Media Types
    const getMediaTypes = async () => {
      try {
        const { data } = await mediaTypes();
        const mediaTypeResponse = data?.data;
        setMediaTypesOptions(mediaTypeResponse);
      } catch (error) {
        console.log("Error obtaining media types", error.message);
      } finally {
        console.log("Done fetching media types");
      }
    };
    getMediaTypes();
  }, []);

  useEffect(() => {
    if (interactTypesOptions.length > 0 && !newRequestData.interactTypeId) {
      setNewRequestData((prev) => ({
        ...prev,
        interactTypeId: getInteractTypeId("App Based"),
      }));
    }
  }, [interactTypesOptions]);

  // Helper function to find the ID for a given interact type name
  const getInteractTypeId = (conceptualName) => {
    const foundType = interactTypesOptions.find(
      (type) => type.value.toLowerCase() === conceptualName.toLowerCase()
    );
    return foundType ? foundType.id : null;
  };

  // NEW: Helper function to find the ID for a given media type name
  const getMediaTypeId = (conceptualName) => {
    const foundType = mediaTypesOptions.find(
      (type) => type.value.toLowerCase() === conceptualName.toLowerCase()
    );
    return foundType ? foundType.id : null; // Return the ID, or null if not found
  };

  const {
    gender,
    mediaTypeId,
    numberOfRespondents,
    requestName,
    description,
  } = // MODIFIED: Destructure mediaTypeId
    newRequestData;

  return (
    <div>
      <div
        className="modal-2"
        style={{
          display: isNewRequestModalOpen ? "flex" : "none",
          opacity: isNewRequestModalOpen ? 1 : 0,
          paddingTop: newRequestStep === "two" ? "300px" : "64px",
        }}
      >
        <div className="modal-container">
          <h2>New Request</h2>
          <div onClick={closeNewRequestModal}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-x icon close"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </div>
          <div className="progress-container bottom-breather push-down">
            <div className="row spaced">
              <h5>Request Details</h5>
              <h5>Demographics</h5>
              <h5>Sample Size</h5>
            </div>
            <div className="progress-tracker">
              <div
                className="progress-bar"
                style={{
                  width:
                    newRequestStep === "two"
                      ? "52%"
                      : newRequestStep === "three"
                      ? "100%"
                      : "10%",
                }}
              ></div>
            </div>
          </div>

          {/* Step 1 */}
          <div
            className="step-1 fill w-form"
            style={{
              display: newRequestStep === "one" ? "block" : "none",
              opacity: newRequestStep === "one" ? 1 : 0,
              height: newRequestStep === "one" ? "100%" : "0px",
              width: "600px",
            }}
          >
            <div>
              <label htmlFor="request-name" className="field-label large">
                What is your request?
              </label>
              <label htmlFor="request-name" className="field-label">
                Name your Request
              </label>
              <input
                type="text"
                id="request-name"
                name="requestName"
                maxLength="256"
                className="input large w-input"
                onChange={handleNewRequestData}
              />
              <label htmlFor="request-description" className="field-label">
                Describe what it is about
              </label>
              <p className="helper nudge-up">
                Be thorough, give details on what you need
              </p>
              <textarea
                id="request-description"
                name="description"
                maxLength="5000"
                placeholder="Explain your request in one sentence..."
                className="input large textarea fill w-input"
                onChange={handleNewRequestData}
              ></textarea>

              {/* <label htmlFor="name-7" className="field-label">
                {" "}
                Campaign{" "}
              </label> */}
              {/* <div className="row" style={{ marginTop: "5px" }}>
                <label className="radio-button-field-3 w-radio">
                  <input
                    onChange={() => {
                      setRequestType("campaign");
                      setNewRequestData({
                        ...newRequestData,
                        mediaTypeId: getMediaTypeId("Photo"), // MODIFIED: Set to Photo ID for campaign
                        interactTypeId: getInteractTypeId("Link Based"),
                      });
                    }}
                    type="radio"
                    id="radio-yes"
                    name="campaign"
                    value="yes"
                    dataname="campaign"
                    data-w-id="6e03107f-92a0-fb5d-4d05-b04402e90f7b"
                    className="w-form-formradioinput w-radio-input"
                    checked={requestType === "campaign"}
                  />
                  <span
                    className="radio-button-label-2 w-form-label"
                    htmlFor="radio-yes"
                  >
                    Yes
                  </span>
                </label>{" "}
                &nbsp; &nbsp; &nbsp;
                <label className="radio-button-field-4 w-radio">
                  <input
                    onChange={() => {
                      setRequestType("request");
                      setNewRequestData({
                        ...newRequestData,
                        mediaTypeId: null, // MODIFIED: Reset mediaType for request (user will select)
                        interactTypeId: getInteractTypeId("App Based"),
                      });
                    }}
                    type="radio"
                    id="radio-no"
                    name="campaign"
                    value="no"
                    dataname="campaign"
                    data-w-id="6db5896c-4075-1848-4dab-872c8e2ce580"
                    className="w-form-formradioinput w-radio-input"
                    checked={requestType === "request"}
                  />
                  <span
                    className="radio-button-label-3 w-form-label"
                    htmlFor="radio-no"
                  >
                    No
                  </span>
                </label>
              </div> */}

              {/* {requestType === "request" && ( */}
              <div>
                <label htmlFor="name-4" className="field-label">
                  How should respondents reply?
                </label>
                <div className="row">
                  <label
                    className={`w-checkbox option ${
                      mediaTypeId === getMediaTypeId("Video") && "active" // MODIFIED: Compare with ID
                    }`}
                  >
                    <input
                      type="radio"
                      id="video"
                      name="mediaType"
                      data-name="Checkbox"
                      onChange={() => setMediaType("Video")} // MODIFIED: Pass conceptual name
                      className="w-checkbox-input checkbox move-left"
                    />
                    <span className="has-icon w-form-label">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-video icon nudge-left nudge-right small"
                      >
                        <polygon points="23 7 16 12 23 17 23 7"></polygon>
                        <rect
                          x="1"
                          y="5"
                          width="15"
                          height="14"
                          rx="2"
                          ry="2"
                        ></rect>
                      </svg>
                      Video
                    </span>
                  </label>
                  <label
                    className={`w-checkbox option ${
                      mediaTypeId === getMediaTypeId("Photo") && "active" // MODIFIED: Compare with ID
                    }`}
                  >
                    <input
                      type="radio"
                      id="photo"
                      name="mediaType"
                      dataname="photo"
                      className="w-checkbox-input checkbox move-left"
                      onChange={() => setMediaType("Photo")} // MODIFIED: Pass conceptual name
                    />
                    <span className="has-icon w-form-label">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-camera icon nudge-left nudge-right small"
                      >
                        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                        <circle cx="12" cy="13" r="4"></circle>
                      </svg>
                      Picture
                    </span>
                  </label>
                  <label
                    className={`w-checkbox option ${
                      mediaTypeId === getMediaTypeId("Audio") && "active" // MODIFIED: Compare with ID
                    }`}
                  >
                    <input
                      type="radio"
                      id="audio"
                      name="mediaType"
                      dataname="audio"
                      onChange={() => setMediaType("Audio")} // MODIFIED: Pass conceptual name
                      className="w-checkbox-input checkbox move-left"
                    />
                    <span className="has-icon w-form-label">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-mic icon nudge-left nudge-right small"
                      >
                        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                        <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                        <line x1="12" y1="19" x2="12" y2="23"></line>
                        <line x1="8" y1="23" x2="16" y2="23"></line>
                      </svg>
                      Audio
                    </span>
                  </label>
                </div>
                <div
                  style={{
                    display: tooltip.step === 2 ? "flex" : "none",
                    width: "300px",
                  }}
                  className=" inline-tooltip-content-3 top-left"
                >
                  {/* step 5 tool tip */}
                  <div className="card-section">
                    <div>Media surveys</div>
                    <p className="move-down">
                      Surveys can be sent as video, picture or audio. Select how
                      you want you Scouts to respond.
                    </p>

                    <div className="inline-tooltip-frame">
                      <span
                        onClick={() =>
                          setTooltip({
                            show: false,
                            type: "",
                            title: "",
                            message: "",
                            step: 0,
                            max_step: 5,
                          })
                        }
                      >
                        Skip tutorial{" "}
                      </span>
                      <button
                        className="inline-tooltip-button"
                        onClick={() =>
                          setTooltip({
                            show: true,
                            type: "",
                            title: "",
                            message: "",
                            step: 3,
                            max_step: 5,
                          })
                        }
                      >
                        Finish{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* )} */}

              {/* MODIFIED: Check mediaTypeId instead of mediaType */}
              {requestName &&
              description &&
              requestType &&
              (requestType === "campaign" || mediaTypeId) ? (
                <button
                  onClick={() => {
                    gotoSurveyStep("campaignTask");
                  }}
                  className="button primary medium large w-button"
                >
                  Next
                </button>
              ) : (
                <DummyButton
                  text="&nbsp; &nbsp; &nbsp; Next &nbsp; &nbsp; &nbsp;"
                  extraClass="large w-button"
                />
              )}
            </div>
          </div>

          {/* campaignTask */}
          <CampaignTask
            activeStep={newRequestStep}
            newRequestData={newRequestData}
            gotoSurveyStep={gotoSurveyStep}
            handleNewRequestData={handleNewRequestData}
          />

          {/* Step 2 */}
          {newRequestStep === "two" && (
            <Demographics
              idToken={idToken}
              client={client}
              user={user}
              gender={gender}
              tooltip={tooltip}
              setTooltip={setTooltip}
              setSportsFan={setSportsFan}
              openModal={openModal}
              surveyType="request"
              activeStep={newRequestStep}
              surveyData={newRequestData}
              setNewSurveyData={setNewRequestData}
              gotoSurveyStep={gotoSurveyStep}
              handleNewSurveyData={handleNewRequestData}
              handleSliderChange={handleSliderChange}
            />
          )}

          {/* Step 3 */}
          <SampleSize
            tooltip={tooltip}
            country={country}
            surveyType="request"
            setTooltip={setTooltip}
            activeStep={newRequestStep}
            insuffientFunds={insuffientFunds}
            showDummyButton={showDummyButton}
            numberOfRespondents={numberOfRespondents}
            surveyData={newRequestData}
            usdPerRespondent_interact={usdPerRespondent_interact}
            versusCreditsPerRespondent={creditsPerRespondent_interact}
            gotoSurveyStep={gotoSurveyStep}
            handleNewSurveyData={handleNewRequestData}
            handleCreateNewSurvey={handleCreateNewRequest}
          />
        </div>
      </div>
    </div>
  );
};

export default NewRequestModal;
